/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import { SelectableValue } from "../models/common/selectable-value";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { TestType, TestUoMType } from "../models/generated/graphql";
import { GeneralFieldController } from "./general-field-controller";
import { getEnumValues } from "../utils/get-enum-values";

export class TestUoMFieldController extends GeneralFieldController {
	public currentIndex = 0;
	override useControlProps(path: string): FlexControlProps {
		this.currentIndex = +(path.split(".").find((e) => Number.isInteger(+e)) || 0);
		const { t } = useTranslation();
		const options = getEnumValues(TestUoMType).map((v) => ({
			label: t(v),
			value: v,
		})) as Array<SelectableValue>;
		const arrayOrNonArrayFieldIndex = this.parent.schema.isArray ? `.${this.currentIndex}` : "";
		const [testType] = useFieldValue<TestType>(`${this.parent.path}${arrayOrNonArrayFieldIndex}.${AttributeIdentifiers.TestType}`);

		function getTestUoMOptionsByTestType(options: Array<SelectableValue>): Array<SelectableValue> {
			switch (testType) {
				case TestType.Hemoglobin:
					return options.filter((o) => o.value === TestUoMType.GramsPerDecilitre);
				case TestType.LactateDehydrogenase:
					return options.filter((o) => o.value === TestUoMType.TimesUln);
				case TestType.AbsoluteReticulocyteCount:
					return options.filter((o) => o.value === TestUoMType.PerMicrolitre);
				case TestType.PlateletCount:
				case TestType.NeutrophilCount:
					return options.filter((o) => o.value === TestUoMType.PerBillionPerLitre);
				default:
					return options;
			}
		}

		return {
			controlType: "typeahead",
			options: getTestUoMOptionsByTestType(options),
			property: "value",
			selectPropertyValue: true,
			freeSolo: false,
		};
	}
}
